import RestService from '../services/rest';

async function getListApplicationType(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/applicationType/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getOptionsApplicationType(search) {
  return RestService.getAuthenticated(
    `panel/applicationType/options?search=${search}`,
  );
}

async function createApplicationType(newApplicationType) {
  return RestService.postAuthenticated(
    'panel/applicationType/create', newApplicationType,
  );
}

async function updateApplicationType(updApplicationType) {
  return RestService.putAuthenticated(
    'panel/applicationType/update', updApplicationType,
  );
}

export default {
  getListApplicationType,
  getOptionsApplicationType,
  createApplicationType,
  updateApplicationType,
};
